import { render } from "./EvacuationSection.vue?vue&type=template&id=10518020"
import script from "./EvacuationSection.ts?vue&type=script&lang=js&external"
export * from "./EvacuationSection.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__